import { render, staticRenderFns } from "./ReceivedEnvelopesCardTable.vue?vue&type=template&id=dc1c2156&lang=pug"
import script from "./ReceivedEnvelopesCardTable.vue?vue&type=script&lang=js"
export * from "./ReceivedEnvelopesCardTable.vue?vue&type=script&lang=js"
import style0 from "./ReceivedEnvelopesCardTable.vue?vue&type=style&index=0&id=dc1c2156&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports